module.exports = __webpack_public_path__ + "img/kantoor-zwaai.7022a280.jpeg";